import { postRequest } from '@helpers/api';

/**
 * Pre-signs a file
 * @param {any} payload - Form data
 * @returns {Promise<*|Object>}
 */
export const preSignFile = payload => postRequest('file-presigned/', payload);

/**
 * Uploads a file
 * @param {string} url - Upload url
 * @param {any} postData - Form data
 * @param {function} [onUploadProgress] - Handles upload progress
 * @returns {Promise<*|Object>}
 */
export const fileUpload = ({ url, postData, onUploadProgress }) =>
  postRequest(url, postData, {
    baseURL: '',
    onSuccess: response => response,
    additionalHeaders: { 'Content-Type': 'multipart/form-data', Authorization: '' },
    axiosOptions: {
      onUploadProgress,
      noAuth: true,
    },
  });
